import { render, staticRenderFns } from "./CrmBotChats.vue?vue&type=template&id=377d303c&scoped=true"
import script from "./CrmBotChats.vue?vue&type=script&lang=js"
export * from "./CrmBotChats.vue?vue&type=script&lang=js"
import style0 from "./CrmBotChats.vue?vue&type=style&index=0&id=377d303c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d303c",
  null
  
)

export default component.exports